import React, { FC, useEffect, useState } from "react";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { useNavigate, useParams } from "react-router-dom";
import { useDialogs } from "../../../../providers/dialogs_provider";
import { getCurrentCustomer, getCurrentUser } from "../../../../core/common_functions";
import { useDoorConfigurationBuilderActions } from "../../../../../store/reducers/door_configuration_builder";
import { DoorConfigurationConditions } from "../../../../models/door_configuration";
import { useConfigurationsService } from "../../../../services/configurations_service";
import ConditionsForm from "../../../../../components/Formik/ConditionForm";
import { FormikErrors, FormikProps } from "formik";
import { CircularProgress } from "@mui/material";
import { CategoryCode } from "../../../../models/category";
import { useOverlapConfigurationsService } from "../../../../services/overlap_configurations_service";

export const ConditionsPage = () => {
  const { base, doorConfigurationBuilder } = useStoreSelector(store => store);
  const navigate = useNavigate();
  const { id } = useParams();
  const dialogs = useDialogs();
  const dispatcher = useStoreDispatch();
  const currentUser = getCurrentUser(base);
  //const currentCustomer = getCurrentCustomer(base);
  const { setStepActive, setStepComplete } = useDoorConfigurationBuilderActions();
  const [isSubmit, setSubmit] = useState<boolean>(false);
  const configurationService = useOverlapConfigurationsService();
  const [refresh, setRefresh] = useState<boolean>(false);
  const checkBeforeSave = (formik: FormikProps<DoorConfigurationConditions>) => {
    if (!currentUser.isCustomer && !formik.values.isServiceCustomer) return null;

    let errors: FormikErrors<DoorConfigurationConditions> = {      
      customClientName: !formik.values.customClientName ? "Campo obbligatorio" : "",
      customClientCity: !formik.values.customClientCity ? "Campo obbligatorio" : "",
      customClientProvince: !formik.values.customClientProvince ? "Campo obbligatorio" : "",
    };

    formik.setErrors(errors);

    let res = Object.entries(errors).filter(values => values[1]);
    return res.length > 0 ? Object.fromEntries(res) : null;
  }
  const submit = async (values: DoorConfigurationConditions,formik: FormikProps<DoorConfigurationConditions>) => {
    try {
      let errors = checkBeforeSave(formik);
      if (errors) return;

      if (!doorConfigurationBuilder.configuration) throw "invalid configuration";

      setSubmit(true);

      await configurationService.setCondizioni(currentUser, doorConfigurationBuilder.configuration.configurationId, values);
      dispatcher(setStepComplete({ stepSlug: "condizioni", isComplete: true }));

      navigate(`/overlap-configurations/${id}/preventivo`);
    } catch (e: any) {
      setSubmit(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  }
  const applyDiscount = async (
    values: DoorConfigurationConditions,
    formik: FormikProps<DoorConfigurationConditions>
  ) => {
    try {
      setRefresh(true);
      if (!doorConfigurationBuilder.configuration) throw "invalid configuration";

      const conditions = await configurationService.aggiornaCondizioni(
          currentUser,
          doorConfigurationBuilder.configuration?.configurationId,
          values
      );

      console.log("Aggiornamento", conditions);
      formik.setValues(conditions);
      setRefresh(false);
    } catch (e: any) {
      setRefresh(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    } 
  };
  useEffect(() => {
    if (!id || isNaN(Number(id)) || !doorConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "condizioni", isActive: true }));
    }
  }, []);

  return (
    <>
        {doorConfigurationBuilder.configuration && (
            <ConditionsForm
                currentUser={currentUser}
                quote_id = {doorConfigurationBuilder.configuration.configurationId}
                applyDiscount={applyDiscount}
                category = {CategoryCode.PortaSezionale}
                handlingSubmit={submit}
                goBack={`/overlap-configurations/${doorConfigurationBuilder.configuration?.configurationId}/accessori-vari`}
            />
        )}
        {refresh && <div className="d-flex align-items-center justify-content-center" style={{
            position: "absolute", height: "100%", width: "100%", top: "0", left: "0",
            backgroundColor: "rgba(255,255,255,0.5)"
          }}>
            <CircularProgress />
          </div>}
    </>
  );
}

export const AmountItem: FC<any> = (props) => {
  if (!props) return <span>ERRORE</span>;

  return (
    <>
      <h6 className="h6">{props.label}</h6>
      <h6 className="h6 text-primary">
        {Number(props.value)
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")} &euro;
      </h6>
    </>
  );
}

export const NumberItem: FC<any> = (props) => {
  return (
    <>
      <h6 className="h6">{props.label}</h6>
      <h6 className="h6 text-primary">
        {Number(props.value).toFixed(props.decimal || 0)}
      </h6>
      
    </>
  );
}